document.addEventListener('DOMContentLoaded', function () {
  const productForms = document.querySelectorAll('product-info, .product');

  function mensajeSeleccion(nombre) {
    const n = (nombre || 'opción').replace(':', '').trim();

    const mensajes = {
      tono: 'Selecciona un tono',
      color: 'Selecciona un color',
      tamaño: 'Selecciona un tamaño',
      fragancia: 'Selecciona una fragancia',
      presentación: 'Selecciona una presentación',
      aroma: 'Selecciona un aroma',
      sabor: 'Selecciona un sabor',
      refill: 'Selecciona un refill',
      talla: 'Selecciona una talla',
      estilo: 'Selecciona un estilo',
      modelo: 'Selecciona un modelo'
    };

    return mensajes[n.toLowerCase()] || `Selecciona: ${n}`;
  }

  productForms.forEach(function (product) {
    const fieldsets = product.querySelectorAll('fieldset.product-form__input');
    const addButton = product.querySelector('button[name="add"]');

    if (!fieldsets.length || !addButton) return;

    const radios = product.querySelectorAll('input[type="radio"]');

    radios.forEach(function (radio) {
      radio.checked = false;
    });

    function opcionFaltante() {
      for (const fieldset of fieldsets) {
        const opciones = fieldset.querySelectorAll('input[type="radio"]');
        if (!opciones.length) continue;

        const seleccionada = fieldset.querySelector('input[type="radio"]:checked');

        if (!seleccionada) {
          const legend = fieldset.querySelector('legend');
          return legend ? legend.childNodes[0].textContent.trim() : 'opción';
        }
      }

      return null;
    }

    function actualizarBoton() {
      const falta = opcionFaltante();
      const textoBoton = addButton.querySelector('span');

      if (falta) {
        addButton.disabled = true;
        addButton.style.opacity = '0.5';

        if (textoBoton) {
          textoBoton.textContent = mensajeSeleccion(falta);
        }
      } else {
        addButton.disabled = false;
        addButton.style.opacity = '1';

        if (textoBoton) {
          textoBoton.textContent = 'Agregar al carrito';
        }
      }
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', actualizarBoton);
    });

    actualizarBoton();
  });
});

